// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3A3GG","title":"ClientInsurance_title__1GTbI","itemText":"ClientInsurance_itemText__3Sg8N"};